<template>
    <sa-page-layout slot="table-body" :btnConfigurazioniVisible="btnConfigurazioniVisible" :btnRefreshVisible="true" :btnNewVisible="true" :linkedit="linkedit" @refresh="onRefresh" :pathResource="pathResource" :showModalLoading="showModalLoading" :linkConfigurazioni="linkConfigurazioni">
        <template slot="table-filter">
            <b-form @submit.prevent="onSubmit">
                <b-row>
                    <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                        <label class="sa-label-data">Codice</label>
                        <b-form-input v-model="filtroStrutturaProvenienza.codice" type="search" placeholder="Inserire codice"></b-form-input>
                    </b-col>
                    <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                        <label class="sa-label-data">Descrizione</label>
                        <b-form-input v-model="filtroStrutturaProvenienza.descrizione" type="search" id="tipo" placeholder="Inserire descrizione"></b-form-input>
                    </b-col>
                    <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12" class="sa-padding-right pt-3 pb-3 text-right">
                        <b-button type="submit" variant="info"> {{ this.$i18n.t("patients.lblFind") }}</b-button>
                        <b-button type="reset" v-on:click="onReset" variant="danger">{{ this.$i18n.t("patients.lblResetFilter") }}</b-button>
                    </b-col>
                </b-row>
            </b-form>
        </template>
        <template slot="table-body">
            <rsa-configurazione-struttura-provenienza-list-component ref="cmpRsaConfigurazioneStrutturaProvenienzaList"></rsa-configurazione-struttura-provenienza-list-component>
        </template>
    </sa-page-layout>
</template>
<script>
import SaPageLayout from "../../../../template/sa/components/layout/contents/SaPageLayout.vue";
import RsaConfigurazioneStrutturaProvenienzaListComponent from "../components/RsaConfigurazioneStrutturaProvenienzaListComponent.vue";
export default {
    components: { SaPageLayout, RsaConfigurazioneStrutturaProvenienzaListComponent },
    data() {
        return {
            filtroStrutturaProvenienza: {
                tipo: null,
                codiceFlusso: null,
            },
            btnNewVisible: false,
            btnConfigurazioniVisible: true,
            pathResource: "",
            linkConfigurazioni: "/configurazioni",
            linkedit: "rsastruttureprovenienze",
            showModalLoading: false,
        };
    },
    mounted() {
        let me = this;
        me.loadData();
        let sessionStorage = window.sessionStorage;
        if (sessionStorage["filtroStrutturaProvenienza"]) {
            me.filtroStrutturaProvenienza = JSON.parse(sessionStorage["filtroStrutturaProvenienza"]);
        }
    },
    methods: {
        loadData() {
            let me = this;
            me.$refs.cmpRsaConfigurazioneStrutturaProvenienzaList.loadData();
        },
        onBeforeLoadData() {
            this.showModalLoading = true;
        },
        onAfterLoadData() {
            this.showModalLoading = false;
        },
        onSubmit() {
            let me = this;
            let sessionStorage = window.sessionStorage;
            sessionStorage["filtroStrutturaProvenienza"] = JSON.stringify(me.filtroStrutturaProvenienza);
            me.loadData();
        },
        onRefresh() {
            let me = this;
            me.loadData();
        },
        onReset() {
            let me = this;
            me.filtroStrutturaProvenienza = { descrizione: null, codice: null };
            let sessionStorage = window.sessionStorage;
            sessionStorage["filtroStrutturaProvenienza"] = JSON.stringify(me.filtroStrutturaProvenienza);
            me.loadData();
        },
        onUpdateFilter(filterData) {
            let me = this;
            me.filtroStrutturaProvenienza = filterData;
        },
    },
};
</script>
